import { ASSETS } from "@/lib/assets";
import { Reveal } from "@/components/site/Reveal";
import { Nfc, ShieldCheck, RefreshCw } from "lucide-react";

export const Features = () => (
  <section id="features" className="relative py-28 md:py-40 scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <Reveal>
        <p className="overline mb-5">Why it is different</p>
        <h2 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-[-0.02em] max-w-3xl mb-16">
          Diagnostics and delivery, engineered as one.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5">
        {/* Microjet delivery — large media tile */}
        <Reveal className="md:col-span-7" delay={0.05}>
          <div className="hover-media group relative h-full min-h-[420px] rounded-2xl overflow-hidden border border-white/10">
            <img src={ASSETS.microjet} alt="ASYA microjet delivery into the epidermis" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-background via-background/30 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-8 md:p-10">
              <span className="overline mb-3">Microjet delivery</span>
              <h3 className="font-serif text-3xl md:text-4xl max-w-md">
                A pressurized micro-jet drives actives past the surface.
              </h3>
              <p className="mt-3 text-sm text-muted-foreground max-w-md">
                Clinically shown to reach deeper into the epidermis than manual application — no rubbing, no waste.
              </p>
            </div>
          </div>
        </Reveal>

        {/* AI classifier tile */}
        <Reveal className="md:col-span-5" delay={0.12}>
          <div className="h-full rounded-2xl border border-white/10 bg-card p-8 md:p-10 flex flex-col justify-between min-h-[420px]">
            <div>
              <span className="overline">GAZE · AI diagnostics</span>
              <h3 className="mt-4 font-serif text-3xl md:text-4xl">
                Eleven conditions, mapped in seconds.
              </h3>
              <p className="mt-3 text-sm text-muted-foreground">
                A proprietary classifier recognizes and localizes distinct skin conditions, then physically changes what VIBE dispenses.
              </p>
            </div>
            <div className="mt-10 grid grid-cols-3 gap-px bg-white/10 rounded-xl overflow-hidden border border-white/10">
              {[["11", "Conditions"], ["82", "Skin Index"], ["9", "US Patents"]].map(([v, l]) => (
                <div key={l} className="bg-card p-5 text-center">
                  <div className="font-serif text-4xl text-primary">{v}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground mt-1">{l}</div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        {/* three supporting tiles */}
        {[
          { icon: Nfc, t: "NFC single-dose", d: "Sealed cartridges auto-log each formulation and eliminate cross-contamination — nothing to clean." },
          { icon: RefreshCw, t: "Closed-loop feedback", d: "Every session is measured, so your treatment adapts to how your skin actually responds." },
          { icon: ShieldCheck, t: "Clinically validated", d: "Peer-reviewed studies, ethics-approved trials and ISO-certified manufacturing partners." },
        ].map((f, i) => (
          <Reveal key={f.t} className="md:col-span-4" delay={0.05 + i * 0.08}>
            <div className="h-full rounded-2xl border border-white/10 bg-card p-8 hover:border-white/25 transition-colors duration-500">
              <f.icon className="w-6 h-6 text-primary mb-8" strokeWidth={1.4} />
              <h3 className="font-serif text-2xl mb-2">{f.t}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{f.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
